var arrayShiftParser = function () {
    return {
        parse: function (sellerId) {
            return Array.isArray(sellerId) ? sellerId[0] : sellerId;
        },
        stringify: function (data) {
            var _a;
            return (_a = data === null || data === void 0 ? void 0 : data.toString()) !== null && _a !== void 0 ? _a : '';
        },
    };
};
export default arrayShiftParser;
//# sourceMappingURL=array-shift-parser.js.map